import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CloseButton } from '../CloseButton';
import styles from '@dtsl/css-info-card/dist/index.module.css';
import Error from '@dtsl/icons/dist/icons/react/Error';
import Information from '@dtsl/icons/dist/icons/react/Information';
import Success from '@dtsl/icons/dist/icons/react/Success';
import Warning from '@dtsl/icons/dist/icons/react/Warning';
function InfoCard(props) {
  const {
    variant,
    className,
    content,
    onClose,
    closable
  } = props;
  const getIcon = variant => {
    switch (variant) {
      case 'info':
        return /*#__PURE__*/React.createElement(Information, {
          className: styles['info-card--info-svg']
        });
      case 'error':
        return /*#__PURE__*/React.createElement(Error, {
          className: styles['info-card--error-svg']
        });
      case 'warning':
        return /*#__PURE__*/React.createElement(Warning, {
          className: styles['info-card--warning-svg']
        });
      case 'success':
        return /*#__PURE__*/React.createElement(Success, {
          className: styles['info-card--success-svg']
        });
    }
  };
  const infoCardClass = classNames({
    [styles['sib-info-card']]: true,
    [styles[variant]]: !!getIcon(variant),
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: infoCardClass,
    role: "alert"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-info-card__icon']
  }, getIcon(variant)), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-info-card__content']
  }, content), closable ? /*#__PURE__*/React.createElement(CloseButton, {
    className: styles['sib-info-card__close-btn'],
    onClick: onClose
  }) : null);
}
InfoCard.defaultProps = {
  className: '',
  variant: 'info',
  content: '',
  closable: false,
  onClose: () => {}
};
InfoCard.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['warning', 'error', 'success', 'info']),
  content: PropTypes.node,
  closable: PropTypes.bool,
  onClose: PropTypes.func
};
export default InfoCard;